var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<md-toolbar class=\"md-active\"> <div class=\"md-toolbar-tools\"> <h2 class=\"md-headline md-margin title\" flex=\"90\"> Normiranec Income Tax Calculator\n<span class=\"motto md-caption\">Thanks FURS :)</span> </h2> <a href=\"https://github.com/sraka1/dutch-tax-income-calculator\" flex=\"10\" layout=\"row\" layout-align=\"end center\"> <span class=\"github-alt\"> <md-tooltip md-direction=\"left\"> Fork me on GitHub </md-tooltip> </span> </a> </div> </md-toolbar>";
ngModule.run(["$templateCache",function(c){c.put("src/toolbar/toolbar.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./toolbar/toolbar.html
 ** module id = 9
 ** module chunks = 0
 **/